module.exports = __webpack_public_path__ + "static/08-3d3da1a27c34fc90380cd306b81d3c9d.jpg";